(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('DataDetailController', DataDetailController);

    DataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Data', 'Formulaire', 'AutreActivite'];

    function DataDetailController($scope, $rootScope, $stateParams, previousState, entity, Data, Formulaire, AutreActivite) {
        var vm = this;

        vm.data = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bhsApp:dataUpdate', function(event, result) {
            vm.data = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
